var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as SDK from '../../lib/sdk';
import * as Backend from '../../backend-api';
import { Metrika } from '../../lib/classes';
import { CustomModal } from '../CustomModal';
import { Leaderboard, Entry, Pedestal } from './Leaderboard';
import { BlueButton } from '../../lib/components';
import { t, PHRASES } from '../../translate';
import './LeaderboardModal.less';
var name = 'LeaderboardModal';
var LeaderboardModal = /** @class */ (function (_super) {
    __extends(LeaderboardModal, _super);
    function LeaderboardModal(props) {
        var _this = _super.call(this, props, name) || this;
        _this.name = name;
        _this.deltaBodyHeight = 55;
        _this.maxBodyHeight = 10000;
        return _this;
    }
    LeaderboardModal.prototype.show = function () {
        _super.prototype.show.call(this);
        this.loadLeaderBoard();
    };
    LeaderboardModal.prototype.getContent = function () {
        var _this = this;
        return [
            this.header(t(PHRASES.Rating)),
            (this.body = this.DIV('&__body scrollbar', [
                this.DIV('&__error', [
                    t(PHRASES.Something_went_wrong),
                    new BlueButton({ onClick: function () { return _this.loadLeaderBoard(); } }, [t(PHRASES.Try_again)]),
                ]),
                this.DIV('&__not-auth', [
                    this.DIV({}, [t(PHRASES.Authorization_required_in_rating)]),
                    new BlueButton({ onClick: function () { return _this.onClickLogin(); } }, [t(PHRASES.Login)]),
                ]),
                (this.pedestal = new Pedestal({})),
                (this.leaderBoard = new Leaderboard({ Entry: Entry, withHeader: false })),
                this.DIV('Loading'),
            ])),
        ];
    };
    LeaderboardModal.prototype.loadLeaderBoard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var auth, options, entries, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.toggleClassName('&_loading', true);
                        this.toggleClassName('&_error', false);
                        this.toggleClassName('&_not-auth', false);
                        if (!FOR_YANDEX) return [3 /*break*/, 2];
                        return [4 /*yield*/, SDK.Auth.checkSafe()];
                    case 1:
                        auth = _a.sent();
                        if (!auth) {
                            return [2 /*return*/, this.toggleNotAuth()];
                        }
                        _a.label = 2;
                    case 2:
                        this.pedestal.clear();
                        this.leaderBoard.clear();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 8, , 9]);
                        if (!FOR_YANDEX) return [3 /*break*/, 5];
                        options = { quantityTop: 25, includeUser: true, quantityAround: 5 };
                        return [4 /*yield*/, SDK.LeaderBoard.getEntries('score', options)];
                    case 4:
                        entries = _a.sent();
                        this.onLoad(entries);
                        return [3 /*break*/, 7];
                    case 5:
                        if (!FOR_VK) return [3 /*break*/, 7];
                        return [4 /*yield*/, Backend.getLeaderBoard()];
                    case 6:
                        data = _a.sent();
                        this.onLoad(data);
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        err_1 = _a.sent();
                        if (err_1.code === 'UNAUTHORIZED' || err_1.code === 'AUTH_HAS_NO_AUTH') {
                            this.toggleClassName('&_not-auth', true);
                        }
                        else {
                            this.toggleClassName('&_error', true);
                        }
                        DEVELOPMENT && console.error(err_1);
                        Metrika.params({ errors: { loadLeaderBoard: 1 } });
                        return [3 /*break*/, 9];
                    case 9:
                        this.toggleClassName('&_loading', false);
                        return [2 /*return*/];
                }
            });
        });
    };
    LeaderboardModal.prototype.onLoad = function (data) {
        if (data && data.entries) {
            var entries = data.entries, userRank = data.userRank;
            this.pedestal.setEntries(entries.slice(0, 3), userRank);
            this.leaderBoard.setEntries(entries.slice(3), userRank);
        }
        else {
            this.toggleError();
        }
    };
    LeaderboardModal.prototype.toggleError = function () {
        this.toggleClassName('&_loading', false);
        this.toggleClassName('&_error', true);
    };
    LeaderboardModal.prototype.toggleNotAuth = function () {
        this.toggleClassName('&_loading', false);
        this.toggleClassName('&_not-auth', true);
    };
    LeaderboardModal.prototype.onClickLogin = function () {
        var _this = this;
        if (FOR_YANDEX) {
            SDK.Auth.authSafe().then(function (ok) {
                if (ok) {
                    setTimeout(function () { return _this.loadLeaderBoard(); }, 100);
                }
            });
        }
    };
    return LeaderboardModal;
}(CustomModal));
export { LeaderboardModal };
